module.exports = __webpack_public_path__ + "3bf28ea434ab7654eb4bdff6503c4a37.MP3";